import { Grid, Typography } from '@mui/material';
import React from 'react';
import GenericTable from '../../../components/atom/GenericTable';
import {
    NEW_DELETE_USERS_TABLE_COLUMNS,
    UPDATE_USERS_TABLE_COLUMNS,
} from '../../../helpers/tableColumnLists';
import { rawDataToReadableData } from '../../../helpers/handleImportedObjects';

const ModalContentSkeleton = ({ modalContent }) => {
    return (
        <Grid container spacing={3}>
            {modalContent?.newItems.length !== 0 && (
                <Grid item xs={12}>
                    <Typography variant="h5">Új elemek</Typography>
                    <GenericTable
                        rows={modalContent?.newItems}
                        columns={NEW_DELETE_USERS_TABLE_COLUMNS}
                        paging={false}
                    />
                </Grid>
            )}
            {modalContent?.updateItems.length !== 0 && (
                <Grid item xs={12}>
                    <Typography variant="h5">Módosításra kerülő elemek</Typography>
                    <GenericTable
                        rows={modalContent?.updateItems.map((row) => ({
                            oldValues: (
                                <pre>
                                    {JSON.stringify(rawDataToReadableData(row.oldValues), null, 2)}
                                </pre>
                            ),
                            newValues: (
                                <pre>
                                    {JSON.stringify(rawDataToReadableData(row.newValues), null, 2)}
                                </pre>
                            ),
                        }))}
                        columns={UPDATE_USERS_TABLE_COLUMNS}
                        paging={false}
                    />
                </Grid>
            )}
            {modalContent?.deleteItems.length !== 0 && (
                <Grid item xs={12}>
                    <Typography variant="h5">Törlésre kerülő elemek</Typography>
                    <GenericTable
                        rows={modalContent?.deleteItems}
                        columns={NEW_DELETE_USERS_TABLE_COLUMNS}
                        paging={false}
                    />
                </Grid>
            )}
        </Grid>
    );
};

export default ModalContentSkeleton;
